import { queryGraphQL } from 'common/util/query';
import { node, nodeWithArgs, toQuery, inlineFragment } from 'common/util/queryHelper';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';
import lodash from 'lodash';

export const ACTIONS = {
    LOADING_INBOX: 'LOADING_INBOX',
    LOAD_MY_TASKS: 'LOAD_MY_TASKS',
    LOAD_MY_SIGNATURE_REQUESTS: 'LOAD_MY_SIGNATURE_REQUESTS',
};

export function loadMySignatureRequests() {
    return async (dispatch) => {
        const query = toQuery(node('mySignatureRequests', [
            'id',
            'status',
            node('createdBy', [
                'id',
                'displayName',
            ]),
            node('requestedFrom', [
                'id',
                'displayName',
            ]),
            node('event', [
                'id',
                'eventType',
                'monitorVisitType',
                'dateOfVisit',
                node('monitor', [
                    'displayName',
                ]),
            ]),
            node('customEvent', [
                'id',
                'institutionId',
                node('eventType', [
                    'displayName',
                ]),
            ]),
            node('delegation', [
                'id',
                node('user', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('rolesManagement', [
                    'id',
                    'name'
                ]),
                'taskIds',
                'startDate',
                'endDate',
            ]),
            'sentDate',
            'binderName',
            'signatureType',
        ]));

        const response = await queryGraphQL(query);
        if(response.errors){
            dispatch(addApplicationMessages('error', response.errors.map(e => e.message)));
        }
        else {
            dispatch({
                type: ACTIONS.LOAD_MY_SIGNATURE_REQUESTS,
                payload: lodash.get(response.data, 'mySignatureRequests'),
            });
        }
    };
}

export function loadMyTasks({ filter, sort, order } = {}) {
    return async (dispatch, getState) => {
        dispatch({type: ACTIONS.LOADING_INBOX});
        const query = toQuery(nodeWithArgs('myTasks', {
            searchText: filter,
            sortBy: sort,
            sortOrder: order
        }, [
            '__typename',
            'id',
            'assignee',
            inlineFragment('SDFATask', [
                'authorDisplayName',
                'shortDescription',
                'title',
                'sentDate',
                'dueDate'
            ])
        ]));

        const response = await queryGraphQL(query);
        if(response.errors){
            dispatch(addApplicationMessages('error', response.errors.map(e => e.message)));
        }
        else {
            dispatch({
                type: ACTIONS.LOAD_MY_TASKS,
                payload: response.data.myTasks
            });
        }
    };
}
